import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import {
  FOR_INVESTORS_SECTIONS,
  FOR_INVESTORS_SUB_SECTIONS,
} from 'constants/businessToolSections/forInvestors';

import useCheckSubSectionAccess from 'hooks/useCheckSubSectionAccess';

import { TextInputControl } from 'components/_basic/Form/TextInput';
import { FormHeader } from 'components/_basic/FormHeader/FormHeader';
import { FormSectionCard } from 'components/_basic/FormSectionCard/FormSectionCard';
import { FORM_SECTION_CARD_VARIANT } from 'components/_basic/FormSectionCard/types';
import {
  MARKETING_NAMES,
  prefix,
} from 'components/BusinessToolForm/Sections/MarketingAndSales/MarketingPlan/utils/form';

import { concatWithDot } from 'helpers/string';

export const MarketingPlan: React.FC = () => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const canAccess = useCheckSubSectionAccess(
    FOR_INVESTORS_SECTIONS.MARKETING_AND_SALES,
    FOR_INVESTORS_SUB_SECTIONS.FOR_INVESTORS_MARKETING_AND_SALES.MARKETING_PLAN,
  );

  return (
    <>
      <FormSectionCard variant={FORM_SECTION_CARD_VARIANT.LARGE}>
        <FormHeader
          locked={!canAccess}
          title={t('marketingAndSales.title')}
          badgeText={t('marketingAndSales.marketing.title')}
          section={FOR_INVESTORS_SECTIONS.MARKETING_AND_SALES}
        />
      </FormSectionCard>
      {/* 5.2.1 */}
      <FormSectionCard
        disabled={!canAccess}
        title={t('marketingAndSales.marketing.advertisingCampaigns')}
        aiFieldName={concatWithDot(prefix, MARKETING_NAMES.ADVERTISING_CAMPAIGNS)}
      >
        <TextInputControl
          multiline
          control={control}
          id={concatWithDot(prefix, MARKETING_NAMES.ADVERTISING_CAMPAIGNS)}
          name={concatWithDot(prefix, MARKETING_NAMES.ADVERTISING_CAMPAIGNS)}
          minRows={3}
          disabled={!canAccess}
          maxLength={1500}
        />
      </FormSectionCard>
      {/* 5.2.4 */}
      <FormSectionCard
        disabled={!canAccess}
        title={t('marketingAndSales.marketing.positioning')}
        aiFieldName={concatWithDot(prefix, MARKETING_NAMES.POSITIONING)}
      >
        <TextInputControl
          multiline
          control={control}
          id={concatWithDot(prefix, MARKETING_NAMES.POSITIONING)}
          name={concatWithDot(prefix, MARKETING_NAMES.POSITIONING)}
          minRows={3}
          disabled={!canAccess}
          maxLength={1500}
        />
      </FormSectionCard>
      {/* 5.2.5 */}
      <FormSectionCard
        disabled={!canAccess}
        title={t('marketingAndSales.marketing.pricingStrategy')}
        aiFieldName={concatWithDot(prefix, MARKETING_NAMES.PRICING_STRATEGY)}
      >
        <TextInputControl
          multiline
          control={control}
          id={concatWithDot(prefix, MARKETING_NAMES.PRICING_STRATEGY)}
          name={concatWithDot(prefix, MARKETING_NAMES.PRICING_STRATEGY)}
          minRows={3}
          disabled={!canAccess}
          maxLength={1500}
        />
      </FormSectionCard>
    </>
  );
};
